// src/store/auth/actions.ts
import { AppDispatch } from "../../../store/store";
import {
  SHOW_LOGIN_MODAL,
  HIDE_LOGIN_MODAL,
  SHOW_REGISTER_MODAL,
  HIDE_REGISTER_MODAL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
} from "../types";
import apiClient from "../../../services/apiClient";

// modal actions
export const showLoginModal = () => ({ type: SHOW_LOGIN_MODAL } as const);
export const hideLoginModal = () => ({ type: HIDE_LOGIN_MODAL } as const);
export const showRegisterModal = () => ({ type: SHOW_REGISTER_MODAL } as const);
export const hideRegisterModal = () => ({ type: HIDE_REGISTER_MODAL } as const);

// auth thunks
export const login =
  (email: string, password: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch({ type: LOGIN_REQUEST });
      const { data } = await apiClient.post("/auth/login", {
        email,
        password,
      });

      const { accessToken, refreshToken, user } = data || {};
      // ✅ EXACT keys expected by apiClient
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      dispatch({ type: LOGIN_SUCCESS, payload: { user } });
      dispatch(hideLoginModal());
      return data;
    } catch (err: any) {
      dispatch({ type: LOGIN_FAILURE, error: err?.message || "Login failed" });
      throw err;
    }
  };

export const logout = () => async (dispatch: AppDispatch) => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    // fire-and-forget best-effort
    await apiClient.post("/auth/logout", { refreshToken });
  } catch {}
  localStorage.clear();
  dispatch({ type: LOGOUT });
};
